import { constants } from '@bedc/constants';

import { Request } from '../../../../api/project/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const ProjectType = SearchDataTableType({
	request: Request,
	columnFields: constants.project.search.columnFields,
	filterIds: constants.project.search.filterIds,
});
